import { type Node } from './../../../ricos-schema/legacy/wix/rich_content/v1/index.js';

export interface NodeWithMetadata {
  node: Node;
  index: number;
  depth: number;
  parent?: NodeWithMetadata;
  children: NodeWithMetadata[];
}

export interface NodeTreeMap {
  [nodeId: string]: NodeWithMetadata;
}

export function buildNodeTree(
  nodes: Node[],
  depth = 0,
  parent?: NodeWithMetadata
): {
  tree: NodeWithMetadata[];
  map: NodeTreeMap;
} {
  const tree: NodeWithMetadata[] = [];
  const map: NodeTreeMap = {};

  nodes.forEach((node, index) => {
    const nodeWithMetadata: NodeWithMetadata = {
      node,
      index,
      depth,
      parent,
      children: [],
    };

    const nodeKey = node.id || `${depth}-${index}`;
    map[nodeKey] = nodeWithMetadata;

    if (node.nodes && node.nodes.length > 0) {
      const { tree: childTree, map: childMap } = buildNodeTree(
        node.nodes,
        depth + 1,
        nodeWithMetadata
      );
      nodeWithMetadata.children = childTree;

      Object.assign(map, childMap);
    }

    tree.push(nodeWithMetadata);
  });

  return { tree, map };
}
